/* eslint-disable react/react-in-jsx-scope */

import React, { memo } from 'react';
import { useNotes } from './hooks';
import { TAB_TEXT, TAB_ACTION } from './constants';
import { NavTabs, NavFilterRow, AddEditModal, NotesTable } from './components';
import SpinnerCircles from '../Spinner/SpinerCircles';
import QCTimelineTab from './QCTimelineTab/QCTimelineTab';

const Notes = memo(
  ({
    onEditNote,
    onDownload,
    onDeleteNote,
    onDeleteNoteRecording,
    user,
    handleChangePagination,
    boxDetails,
    onConfirm,
  }) => {
    const {
      noteMode: mode,
      onPageChange,
      data,
      shouldFilter,
      setData,
      handleEditNote,
      handleDeleteNote,
      modal,
      handleModal,
      handleTabChange,
      selectedTab,
      filterDropDownOptions,
      handleFilterOptionsDropDownChange,
      selectedOption,
      showNewNoteButton,
      debouncedHandleChange: handleChange,
      updateFetchQuery,
      boxNotes,
      setBoxNotes,
      onDeleteRecording,
      onKeyPress,
      onSavePress,
      sort,
      handleSortNotes,
      notesLoading,
    } = useNotes(onDeleteNote, boxDetails, onDeleteNoteRecording);

    return (
      <>
        <NavTabs handleTabChange={handleTabChange} selectedTab={selectedTab} user={user} />
        {selectedTab === TAB_ACTION.QC ? (
          <QCTimelineTab key={boxDetails?.serialNumber} serialNumber={boxDetails?.serialNumber} />
        ) : (
          <>
            {notesLoading && (
              <div className='d-flex align-items-center justify-content-center' style={{ height: 500 }}>
                <SpinnerCircles red />
              </div>
            )}
            {!notesLoading && (
              <>
                <AddEditModal
                  mode={mode}
                  isOpen={modal}
                  handleModal={handleModal}
                  onConfirm={onConfirm}
                  onEditNote={onEditNote}
                  data={data}
                  setData={setData}
                  updateFetchQuery={updateFetchQuery}
                  selectedTab={selectedTab}
                />
                <NavFilterRow
                  showNewNoteButton={showNewNoteButton}
                  handleModal={handleModal}
                  selectedOption={selectedOption}
                  handleFilterOptionsDropDownChange={handleFilterOptionsDropDownChange}
                  filterDropDownOptions={filterDropDownOptions}
                  onKeyPress={onKeyPress}
                  handleChange={handleChange}
                  onSavePress={onSavePress}
                />
                <NotesTable
                  handleEditNote={handleEditNote}
                  onEditNote={onEditNote}
                  boxNotes={boxNotes}
                  setBoxNotes={setBoxNotes}
                  onDownload={onDownload}
                  onDeleteRecording={onDeleteRecording}
                  handleDeleteNote={handleDeleteNote}
                  handleChangePagination={handleChangePagination}
                  onPageChange={onPageChange}
                  updateFetchQuery={updateFetchQuery}
                  shouldFilter={shouldFilter}
                  user={user}
                  box={boxDetails}
                  sortValue={sort}
                  onSort={handleSortNotes}
                  selectedTab={selectedTab}
                />
              </>
            )}
          </>
        )}
      </>
    );
  },
);

export default Notes;
